// components

import { ConsultaPosComponent } from './components/pos/consulta-pos/consulta-pos.component';
import { ConsultaComponent } from './components/tradicional/consulta/consulta.component';
import { ConsultaColegioComponent } from './components/colegio/consulta-colegio/consulta-colegio.component';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { ConsultaMedicinaComponent } from './components/medicina/consulta-medicina/consulta-medicina.component';
import { BloqueadoColegioComponent } from './components/colegio/bloqueado-colegio/bloqueado-colegio.component';
import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

const /** @type {?} */ APP_ROUTING: Routes = [
    {
        path: 'nota-aluno/tradicional/:codigoEmpresa/:codigoInstituicao/:rgmAluno/:codigoAluno',
        component: ConsultaComponent
    },
    {
        path: 'nota-aluno/pos/:codigoEmpresa/:codigoInstituicao/:rgmAluno',
        component: ConsultaPosComponent
    },
    {
        path: 'nota-aluno/colegio/:codigoEmpresa/:codigoInstituicao/:rgmAluno/:codigoAluno/:codigoCurso',
        component: ConsultaColegioComponent
    },
    {
        path: 'nota-aluno/pbl/:codigoEmpresa/:codigoInstituicao/:rgmAluno/:codigoAluno',
        component: ConsultaMedicinaComponent
    },
    {
        path: 'nota-aluno/colegio/bloqueado/:mensagem',
        component: BloqueadoColegioComponent
    },
    { path: 'nota-aluno/teste-notas', component: NotfoundComponent },
    { path: 'nota-aluno/404', component: NotfoundComponent }
];

export const /** @type {?} */ routes: ModuleWithProviders = RouterModule.forRoot(APP_ROUTING);
